
import { Vue, Component, Watch } from 'vue-property-decorator'
import SendCredits from '@/modules/credits/SendCredits.vue'
import CreditsHistory from '@/modules/credits/CreditsHistory.vue'

@Component({
  components: { SendCredits, CreditsHistory },
})
export default class CreditsIndex extends Vue {
  @Watch('$route')
  onRouteChange() {}
}
